import { Toast } from '@marketertechnologies/ui-library';
import { useQuery } from '@tanstack/react-query';

import { Asset, Location } from '~/types';
import fetcher from '~/utils/fetcher';
import { getStorefrontUrl } from '~/utils/getStorefrontUrl';

type WithErrors = {
  errors: Record<string, string>;
};

export type SummaryData = {
  campaign_duration_elapsed_days: number;
  campaign_duration_elapsed_hours: number;
  campaign_duration_total_days: number;
  campaign_duration_total_hours: number;
  company_logo: Asset | null;
  cover_image: Asset | null;
  location: Location;
  uuid: string;
  earliest_start_date: string | null;
  latest_end_date: string | null;
  template_background_color?: string;
  template_text_color?: string;
  template_logo?: Asset | null;
  promotable_type?: 'broker' | 'existing_home';
  report_name?: string;
};

type SummaryResponse = SummaryData | WithErrors;

export const fetchSummary = async (reportId: string) => {
  const response = await fetcher<SummaryResponse>(
    getStorefrontUrl(`/api/v1/property_report/${reportId}/summary`).toString(),
  );

  if ('errors' in response) {
    const errors = Object.values(response.errors);

    if (!errors.length) return;

    Toast.Error(String(errors));

    return null;
  }

  return response as SummaryData;
};

export const useSummary = (reportId?: string) =>
  useQuery({
    queryKey: ['summary', reportId],
    queryFn: () => fetchSummary(reportId!),
    staleTime: 15 * 60 * 1000,
    enabled: !!reportId,
  });
